import React, { useContext } from 'react'
import { H4 } from '@jarvis.oddle/core/components/Typo'
import Div from '@jarvis.oddle/core/components/Div'
import { Container } from './Elements'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

interface AddressProps {
  onClick: () => void
  storeOrder: {
    data: Oms.V4.StoreOrder
  }
}

const Address = ({ onClick, storeOrder }: AddressProps): JSX.Element => {
  const { isPickup, storeName, storeAddress, storePhone, deliveryAddress } =
    storeOrder.data
  const { t } = useContext(TranslationContext)
  return (
    <Container data-testid='collectionDetails.address' onClick={onClick}>
      {isPickup && storeName && storeAddress ? (
        <Div>
          <H4 normalised bold>
            {t('Pickup Store')}
          </H4>
          <H4 normalised>{storeName}</H4>
          <H4 normalised>{storeAddress}</H4>
          {storePhone && (
            <H4 normalised>
              {t('Phone: _storePhone_', { storePhone: storePhone })}
            </H4>
          )}
        </Div>
      ) : (
        deliveryAddress && (
          <Div>
            <H4 normalised bold>
              {t('Delivery Address')}
            </H4>
            <H4 normalised>{deliveryAddress}</H4>
          </Div>
        )
      )}
    </Container>
  )
}

export default Address
